import React, { useState, useEffect } from "react";
import DashboardMantenimientos from "./components/Dashboard";
import ModalCrearEquipo from "./components/ModalCrearEquipo";
import ModalCrearItem from "./components/ModalCrearItem";
import EquipoCard from "./components/EquipoCard";
import CalendarioITV from "./components/Calendario";
import Login from "./components/Login";
import ModalCrearUsuario from "./components/ModalCrearUsuario";
import ListaUsuarios from "./components/ListaUsuarios";
import logo from "./assets/logo.png";
import {
  FiTool, FiTruck, FiSettings, FiPackage, FiCalendar,
  FiUserPlus, FiUsers, FiLogOut,
} from "react-icons/fi";
import {
  HiOutlineCurrencyEuro,
  HiOutlineViewGrid,
} from "react-icons/hi";
import { Routes, Route, NavLink, Navigate, useLocation } from "react-router-dom";
import EquipoDetalle from "./components/EquipoDetalle";
import { TableSkeleton } from "./components/Skeleton";
import { useConfirm } from "./ConfirmContext";

import "./styles.css";
import {
  listarVehiculos,
  listarMaquinaria,
  listarUtillaje,
  listarAlmacen,
  borrarVehiculo,
  borrarMaquinaria,
  borrarUtillaje,
  borrarItem,
  listarUsuarios,
  crearUsuario,
  actualizarUsuario,
  borrarUsuario,
  autenticarUsuario,
  login,
  logout,
  API_BASE,
} from "./api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  const [usuario, setUsuario] = useState(null);
  const [cargandoUsuario, setCargandoUsuario] = useState(true);
  const [cargandoDatos, setCargandoDatos] = useState(false);
  const [sidebarVisible, setSidebarVisible] = useState(false);
  const confirm = useConfirm();

  useEffect(() => {
    const stored = localStorage.getItem("currentUser");
    if (stored) {
      try {
        const userData = JSON.parse(stored);
        if (
          userData.username &&
          userData.token &&
          (userData.rol === "admin" || userData.rol === "user")
        ) {
          setUsuario(userData);
        } else {
          localStorage.removeItem("currentUser");
        }
      } catch {
        localStorage.removeItem("currentUser");
      }
    }
    setCargandoUsuario(false);
  }, []);

  const handleLogin = async (username, password) => {
    const rol = await autenticarUsuario(username, password);
    const stored = localStorage.getItem("currentUser");
    setUsuario(JSON.parse(stored));
  };

  const handleLogout = () => {
    logout();
    setUsuario(null);
    setSidebarVisible(false);
  };

  const [busqueda, setBusqueda] = useState("");
  const [vehiculos, setVehiculos] = useState([]);
  const [maquinaria, setMaquinaria] = useState([]);
  const [utillaje, setUtillaje] = useState([]);
  const [almacen, setAlmacen] = useState([]);


  const [modalEquipoVisible, setModalEquipoVisible] = useState(false);
  const [modalItemVisible, setModalItemVisible] = useState(false);
  const [equipoEditando, setEquipoEditando] = useState(null);
  const [itemEditando, setItemEditando] = useState(null);
  const [tipoPorDefecto, setTipoPorDefecto] = useState(null);

  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(8);

  const [usuariosLista, setUsuariosLista] = useState([]);
  const [modalCrearUsuarioVisible, setModalCrearUsuarioVisible] =
    useState(false);
  const [modalListaUsuariosVisible, setModalListaUsuariosVisible] =
    useState(false);

  const tituloSingular = {
    Vehículos: "Vehículo",
    "Maquinaria - Vehículos Pesados": "Maquinaria",
    Utillaje: "Utillaje",
    Almacén: "Item",
  };

  const ordenarPorNombre = (lista) =>
    [...lista].sort((a, b) =>
      (a.nombre || "").localeCompare(b.nombre || "", "es", {
        sensitivity: "base",
      })
    );

  const fetchDatos = async () => {
    setCargandoDatos(true);
    try {
      const [v, m, u, a] = await Promise.all([
        listarVehiculos(),
        listarMaquinaria(),
        listarUtillaje(),
        listarAlmacen(),
      ]);
      setVehiculos(ordenarPorNombre(v));
      setMaquinaria(ordenarPorNombre(m));
      setUtillaje(ordenarPorNombre(u));
      setAlmacen(ordenarPorNombre(a));
    } catch (err) {
      console.error("Error cargando datos:", err);
      toast.error("Error al cargar los datos");
    } finally {
      // Small delay for better visual feel of the skeleton
      setTimeout(() => setCargandoDatos(false), 400);
    }
  };

  const fetchUsuarios = async () => {
    try {
      const data = await listarUsuarios();
      setUsuariosLista(data);
    } catch (err) {
      console.error("Error al listar usuarios:", err);
    }
  };

  useEffect(() => {
    if (!usuario) return;
    fetchDatos();
    if (usuario.rol === "admin") {
      fetchUsuarios();
    }
  }, [usuario]);

  const location = useLocation();

  useEffect(() => {
    setPage(0);
  }, [busqueda, location.pathname, pageSize]);


  const filtrarItems = (items) => {
    if (!busqueda) return items;
    const texto = busqueda.toLowerCase();

    return items.filter((i) => {
      const nombre = i.nombre?.toLowerCase() || "";
      const matricula = i.matricula?.toLowerCase() || "";
      const referencia = i.referencia?.toLowerCase() || "";
      const referenciaInterna = i.referencia_interna?.toLowerCase() || "";
      const tipo = i.tipo?.toLowerCase() || "";

      return (
        nombre.includes(texto) ||
        matricula.includes(texto) ||
        referencia.includes(texto) ||
        referenciaInterna.includes(texto) ||
        tipo.includes(texto)
      );
    });
  };

  const handleEditar = (item, tipoObjeto) => {
    if (tipoObjeto === "almacen") {
      setItemEditando(item);
      setModalItemVisible(true);
    } else {
      setEquipoEditando({ ...item, tipoObjeto });
      setTipoPorDefecto(tipoObjeto);
      setModalEquipoVisible(true);
    }
  };

  const handleEliminar = async (itemId, tipoObjeto) => {
    const isConfirmed = await confirm({
      title: "¿Eliminar item?",
      message: "¿Estás seguro de que deseas eliminar este item? Esta acción no se puede deshacer.",
    });

    if (isConfirmed) {
      try {
        switch (tipoObjeto) {
          case "vehiculo":
            await borrarVehiculo(itemId);
            break;
          case "maquinaria":
            await borrarMaquinaria(itemId);
            break;
          case "utillaje":
            await borrarUtillaje(itemId);
            break;
          case "almacen":
            await borrarItem(itemId);
            break;
          default:
            return;
        }
        await fetchDatos();
        toast.success("Item eliminado correctamente");
      } catch (err) {
        console.error("Error eliminando:", err);
        toast.error("No se pudo eliminar el item");
      }
    }
  };

  const handleActualizarEquipo = (mantenimientoRes) => {
    if (!mantenimientoRes) return;

    setVehiculos((prev) =>
      prev.map((v) =>
        mantenimientoRes.vehiculo_id === v.id
          ? {
            ...v,
            km_actual: mantenimientoRes.vehiculo.km_actual,
            km_ultimo_mantenimiento:
              mantenimientoRes.vehiculo.km_ultimo_mantenimiento,
          }
          : v
      )
    );

    setMaquinaria((prev) =>
      prev.map((m) =>
        mantenimientoRes.maquinaria_id === m.id
          ? {
            ...m,
            horas_actuales: mantenimientoRes.maquinaria.horas_actuales,
            horas_ultimo_mantenimiento:
              mantenimientoRes.maquinaria.horas_ultimo_mantenimiento,
          }
          : m
      )
    );

    setUtillaje((prev) =>
      prev.map((u) =>
        mantenimientoRes.utillaje_id === u.id
          ? {
            ...u,
            horas_actuales: mantenimientoRes.utillaje.horas_actuales,
            horas_ultimo_mantenimiento:
              mantenimientoRes.utillaje.horas_ultimo_mantenimiento,
          }
          : u
      )
    );
  };

  const handleCrearUsuario = async (username, password, rolNuevo) => {
    try {
      await crearUsuario(username, password, rolNuevo);
      setModalCrearUsuarioVisible(false);
      await fetchUsuarios();
    } catch (err) {
      console.error("Error al crear usuario:", err);
      toast.error(err.message || "Error al crear usuario");
    }
  };

  const handleEliminarUsuario = async (username) => {
    try {
      await borrarUsuario(username);
      await fetchUsuarios();
    } catch (err) {
      toast.error(err.message || "Error eliminando usuario");
    }
  };

  const handleActualizarUsuario = async (datos) => {
    try {
      await actualizarUsuario(datos);
      toast.success(`Usuario ${datos.username} actualizado`);
      await fetchUsuarios();
    } catch (err) {
      console.error("Error actualizando usuario:", err);
      toast.error("Error actualizando usuario");
    }
  };

  const renderDashboardEquipos = (items, tipo, titulo) => {
    const filtrados = filtrarItems(items);
    const totalItems = filtrados.length;
    const totalPages = Math.max(1, Math.ceil(totalItems / pageSize));
    const start = page * pageSize;
    const end = start + pageSize;
    const currentPageItems = filtrados.slice(start, end);

    const goPrev = () => setPage((p) => Math.max(0, p - 1));
    const goNext = () => setPage((p) => Math.min(totalPages - 1, p + 1));
    const goTo = (p) => setPage(Math.max(0, Math.min(totalPages - 1, p)));

    const mostrarITV = tipo === "vehiculo" || tipo === "maquinaria";

    const claseGrid = tipo === "almacen" ? "grid-almacen" : "grid-equipos";

    return (
      <div className="dashboard-container">
        <div className="dashboard-header">
          <h1>{titulo}</h1>
        </div>

        <div className="dashboard-controls">
          <input
            type="text"
            placeholder={`Buscar ${titulo.toLowerCase()}...`}
            value={busqueda}
            onChange={(e) => setBusqueda(e.target.value)}
            className="buscador"
          />
          <button
            className="botonAzul crear-equipo"
            onClick={() => {
              if (tipo === "almacen") {
                setItemEditando(null);
                setModalItemVisible(true);
              } else {
                setEquipoEditando({ tipoObjeto: tipo });
                setTipoPorDefecto(tipo);
                setModalEquipoVisible(true);
              }
            }}
          >
            + Crear {tituloSingular[titulo]}
          </button>
        </div>

        <div className="tabla-container">
          <div className={`lista-encabezado ${claseGrid}`}>
            <div className="col-titulo">Nombre</div>

            {tipo === "almacen" ? (
              <div className="col-matricula">Referencia</div>
            ) : (
              <>
                <div className="col-matricula">Matrícula / SN</div>
                <div className="col-referencia">Referencia</div>
              </>
            )}

            <div className="col-tipo">
              {tipo === "almacen" ? "Cantidad" : "Tipo"}
            </div>

            {mostrarITV && <div className="col-fecha">Próxima ITV</div>}

            <div className="col-acciones">Acciones</div>
          </div>

          {cargandoDatos ? (
            <TableSkeleton rows={8} columns={tipo === "almacen" ? 4 : (mostrarITV ? 5 : 4)} />
          ) : currentPageItems.length > 0 ? (
            currentPageItems.map((e) => (
              <EquipoCard
                key={e.id}
                equipo={e}
                tipo={tipo}
                mostrarITV={mostrarITV}
                onEditar={(eq) => handleEditar(eq, tipo)}
                onEliminar={(id) => handleEliminar(id, tipo)}
              />
            ))
          ) : (
            <div className="no-resultados">No hay registros disponibles.</div>
          )}
        </div>

        <div className="paginacion-container">
          <div>
            <label>
              Mostrar:
              <select
                value={pageSize}
                onChange={(e) => {
                  setPageSize(parseInt(e.target.value));
                  setPage(0);
                }}
                style={{ marginLeft: 5 }}
              >
                <option value={8}>8</option>
                <option value={15}>15</option>
                <option value={50}>50</option>
              </select>
            </label>
          </div>

          <div
            className="paginacion-numeros"
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "8px",
              marginTop: "10px",
            }}
          >
            <button onClick={goPrev} disabled={page === 0}>
              Anterior
            </button>
            {Array.from({ length: totalPages }).map((_, idx) => (
              <button
                key={idx}
                className={idx === page ? "activo" : ""}
                onClick={() => goTo(idx)}
              >
                {idx + 1}
              </button>
            ))}
            <button onClick={goNext} disabled={page === totalPages - 1}>
              Siguiente
            </button>
          </div>
        </div>
      </div>
    );
  };

  if (cargandoUsuario) {
    return (
      <div className="initial-loader">
        <div className="spinner-large"></div>
        <p>Cargando aplicación...</p>
      </div>
    );
  }

  if (!usuario) {
    return <Login onLogin={handleLogin} />;
  }

  const cerrarMenuMovil = () => {
    if (sidebarVisible) {
      setSidebarVisible(false);
    }
  };

  const navItems = [
    { id: "mantenimientos", label: "Mantenimientos", icon: <FiTool /> },
    { id: "vehiculos", label: "Vehículos", icon: <FiTruck /> },
    { id: "maquinaria", label: "Maquinaria", icon: <FiSettings /> },
    { id: "utillaje", label: "Utillaje", icon: <FiTool /> },
    { id: "almacen", label: "Almacén", icon: <FiPackage /> },
    { id: "itv", label: "Calendario ITV", icon: <FiCalendar /> },

  ];

  return (
    <div className="app-container">
      <button
        className="btn-hamburguesa"
        onClick={() => setSidebarVisible(!sidebarVisible)}
        aria-label="Abrir menú"
      >
        ☰
      </button>

      <aside className={`sidebar ${sidebarVisible ? "visible" : ""}`}>
        {/* Brand */}
        <div className="sidebar-brand">
          <div className="brand-logo">M</div>
          <span>Mantenimientos</span>
        </div>

        <h2>Navegación</h2>

        <nav className="sidebar-nav">
          {navItems.map(({ id, label, icon }) => (
            <NavLink
              key={id}
              to={id === "mantenimientos" ? "/" : `/${id}`}
              end={id === "mantenimientos"}
              className={({ isActive }) => isActive ? "activo" : ""}
              onClick={() => setSidebarVisible(false)}
            >

              {icon}
              {label}
            </NavLink>
          ))}
        </nav>


        {usuario.rol === "admin" && (
          <>
            <h2 style={{ marginTop: 24 }}>Administración</h2>

            <button
              onClick={() => {
                setModalCrearUsuarioVisible(true);
                setSidebarVisible(false);
              }}
            >
              <FiUserPlus /> Crear Usuario
            </button>
            <button
              onClick={() => {
                fetchUsuarios();
                setModalListaUsuariosVisible(true);
                setSidebarVisible(false);
              }}
            >
              <FiUsers /> Ver Usuarios
            </button>
          </>
        )}

        <div className="sidebar-separator" />

        <div className="sidebar-portals-section">
          <h2>Portales</h2>
          <div className="sidebar-portals-grid">
            <a
              href="https://licitaciones.vipeca.com"
              target="_blank"
              rel="noopener noreferrer"
              className="portal-card"
            >
              <HiOutlineViewGrid size={24} />
              <span>Licitaciones</span>
            </a>
            <a
              href="https://subvenciones.vipeca.com"
              target="_blank"
              rel="noopener noreferrer"
              className="portal-card"
            >
              <HiOutlineCurrencyEuro size={24} />
              <span>Subvenciones</span>
            </a>
          </div>
        </div>

        <div style={{ paddingTop: 16 }}>
          <div style={{
            padding: "10px 14px",
            borderRadius: "var(--radius-md)",
            background: "rgba(15,23,42,0.03)",
            fontSize: "0.82rem",
            color: "var(--text-secondary)",
            marginBottom: 8,
            display: "flex",
            alignItems: "center",
            gap: 8,
          }}>
            <span style={{
              width: 28, height: 28, borderRadius: "50%",
              background: "linear-gradient(135deg,var(--accent-primary),var(--accent-success))",
              color: "#fff", display: "flex", alignItems: "center",
              justifyContent: "center", fontWeight: 700, fontSize: "0.75rem", flexShrink: 0,
            }}>
              {usuario.username?.[0]?.toUpperCase()}
            </span>
            <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
              {usuario.username}
            </span>
          </div>
          <button
            onClick={handleLogout}
            style={{ color: "var(--accent-danger)" }}
          >
            <FiLogOut /> Cerrar sesión

          </button>
        </div>
      </aside>

      <main className="main-content" onClick={cerrarMenuMovil}>
        <div className="header-logo">
          <img src={logo} alt="Logo" />
        </div>
        <Routes>
          <Route path="/" element={
            <DashboardMantenimientos
              usuario={usuario}
              onLogout={handleLogout}
              onActualizarDatos={fetchDatos}
              onGuardar={handleActualizarEquipo}
            />
          } />
          
          <Route path="/vehiculos" element={
            renderDashboardEquipos(vehiculos, "vehiculo", "Vehículos")
          } />

          <Route path="/maquinaria" element={
            renderDashboardEquipos(maquinaria, "maquinaria", "Maquinaria - Vehículos Pesados")
          } />

          <Route path="/utillaje" element={
            renderDashboardEquipos(utillaje, "utillaje", "Utillaje")
          } />

          <Route path="/almacen" element={
            renderDashboardEquipos(almacen, "almacen", "Almacen")
          } />

          <Route path="/itv" element={
            <CalendarioITV onCerrar={() => {}} />
          } />

          <Route path="/:ref" element={<EquipoDetalle usuario={usuario} />} />
        </Routes>

      </main>

      {modalEquipoVisible && (
        <ModalCrearEquipo
          equipo={equipoEditando}
          tipoPorDefecto={tipoPorDefecto}
          onClose={() => {
            setModalEquipoVisible(false);
            fetchDatos();
          }}
        />
      )}

      {modalItemVisible && (
        <ModalCrearItem
          item={itemEditando}
          onClose={() => {
            setModalItemVisible(false);
            fetchDatos();
          }}
        />
      )}

      {modalCrearUsuarioVisible && (
        <ModalCrearUsuario
          visible={modalCrearUsuarioVisible}
          onClose={() => setModalCrearUsuarioVisible(false)}
          onGuardar={handleCrearUsuario}
        />
      )}

      {modalListaUsuariosVisible && (
        <ListaUsuarios
          visible={modalListaUsuariosVisible}
          onClose={() => setModalListaUsuariosVisible(false)}
          usuarios={usuariosLista}
          onEliminar={handleEliminarUsuario}
          onActualizar={handleActualizarUsuario}
          usuario={usuario}
        />
      )}
      <ToastContainer position="bottom-right" autoClose={3000} />
    </div>
  );
}

export default App;
